import { c as _c } from "react/compiler-runtime";
import { Drawer, Heading, Icon, LinkList, LinkListItem } from '@petsmart-ui/sparky';
import { useRouter } from 'next/navigation';
import { SidebarItem } from '@/components/Menu/SidebarItem';
import { USER_MENU_ITEMS } from '@/constants';
import { useUserData } from '@/hooks';
import type { NavigationDrawerProps } from '@/types';
import '@/components/Menu/menu.scss';
import './userMenuDrawer.scss';
const componentClassName = 'user-menu-drawer';
export function UserMenuDrawer(t0) {
  const $ = _c(27);
  const {
    handleClose,
    isActive
  } = t0;
  const router = useRouter();
  const userData = useUserData();
  let t1;
  if ($[0] !== router) {
    t1 = () => {
      router.push("/auth/login");
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLogout = t1;
  const displayName = userData.name || userData.email;
  const displayEmail = userData.name ? userData.email : "";
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon className={`${componentClassName}__header-content__icon`} name="account-circle-outline" size="md" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== displayName) {
    t3 = displayName && <Heading className={`${componentClassName}__header-content__heading`} tagName="h6">{displayName}</Heading>;
    $[3] = displayName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== displayEmail) {
    t4 = displayEmail && <div className={`${componentClassName}__header-content__email`}>{displayEmail}</div>;
    $[5] = displayEmail;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== userData.groups) {
    t5 = userData.groups.map(_temp);
    $[7] = userData.groups;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <div className={`${componentClassName}__header-content__role-list`}>{t5}</div>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t6) {
    t7 = <Drawer.Header className={`${componentClassName}__header`}><div className={`${componentClassName}__header-content`}>{t2}{t3}{t4}{t6}</div></Drawer.Header>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== handleClose) {
    t8 = USER_MENU_ITEMS.map(item => <SidebarItem key={item.title} item={item} handleClose={handleClose} />);
    $[15] = handleClose;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== handleLogout) {
    t9 = <LinkListItem text="Logout" onClick={handleLogout} />;
    $[17] = handleLogout;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <Drawer.Body className={`${componentClassName}__body`}><aside className={componentClassName}><nav className={`merchant-menu ${componentClassName}__body__items-list`}><LinkList>{t8}{t9}</LinkList></nav></aside></Drawer.Body>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== handleClose || $[23] !== isActive || $[24] !== t10 || $[25] !== t7) {
    t11 = <Drawer data-testid={componentClassName} align="right" isActive={isActive} onClose={handleClose} ariaLabelledBy={componentClassName} className={componentClassName}>{t7}{t10}</Drawer>;
    $[22] = handleClose;
    $[23] = isActive;
    $[24] = t10;
    $[25] = t7;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
}
function _temp(group) {
  return <div key={group} className={`${componentClassName}__header-content__role`}>{group}</div>;
}